import { render, staticRenderFns } from "./CompanyLogo.vue?vue&type=template&id=6637e4e6&scoped=true&"
import script from "./CompanyLogo.vue?vue&type=script&lang=ts&"
export * from "./CompanyLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637e4e6",
  null
  
)

export default component.exports